<template>
  <div class="m-wrap-target">
    <template v-if="len">
      <div class="target-wrap" v-for="(target, i) in value" :key="target.targetingId">
        <header>
          <dl>{{ target.targetingName }}</dl>
          <Icon
            v-if="!disabled"
            type="ios-trash-outline"
            size="22"
            color="#ff2200"
            style="cursor: pointer"
            @click="$emit('on-delete', i)"
          />
        </header>
        <div class="target-content">
          <ul>
            <template v-for="(item, id) in target.targets">
              <li v-if="!item.hide" :key="id">
                <dt>{{ item.name }}：</dt>
                <dd v-if="item.all">不限</dd>
                <dd v-else>
                  <span v-for="(ret, i) in item.values" :key="i"> {{ i ? '、' : '' }}{{ ret }} </span>
                </dd>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </template>
    <div class="c-nodata" v-else>
      <Icon type="ios-filing-outline" size="92" color="#efefef" />
      <span>请选择定向包</span>
    </div>

    <targeter
      v-model="targetModal"
      :data="targetList"
      :total="targetTotal"
      :open-id="defaultOpenId"
      :platform="defaultPlatform"
      :loading="loading"
      @on-cancel="targetModal = false"
      @on-search="searchTarget"
      @on-change="filterTarget"
      @on-select="saveTarget"
      @on-platform="changePlatform"
    />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, timeout } from '@/common/js/utils'
import { deCompile } from '@/common/js/decompile'
import { getTargetingData } from '@/api/manage.model'

import Targeter from '@/components/target/manager.vue'
export default {
  name: 'targetSelect',
  components: { Targeter },
  computed: {
    len() {
      return this.value.length
    }
  },
  props: {
    value: {
      type: Array
    },
    openId: {
      type: [Number, String]
    },
    media: {
      type: [Number, String]
    },
    platform: {
      type: [Number, String]
    },
    orignData: {
      type: Object,
      default() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getData(filter) {
      let params = { mediaId: this.media, pageIndex: 1, pageSize: 10 }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))

      this.loading = true
      getTargetingData(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.targetTotal = total_number || 0
            this.targetList = list.map((ret) => {
              ret.targets = deCompile(ret.targetingParamJson, this.orignData)
              return ret
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    selectTarget() {
      this.targetModal = true
      this.setOpenId()
      // this.getData(this.params || {})
    },
    filterTarget(params) {
      this.getData(params)
    },
    searchTarget(params) {
      params.pageIndex = 1
      this.getData(params)
    },
    changePlatform(id) {
      this.defaultPlatform = id
    },
    saveTarget(meta) {
      console.log(meta)
      this.$emit('on-select', meta)
      timeout(0).then(() => {
        // 记录上次成功opId
        this.setOperatorStorage('select-target', this.params.createOpId || -1)
        this.targetModal = false
      })
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-target')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
      this.defaultPlatform = this.platform || ''
    }
  },
  data() {
    return {
      loading: null,
      targetModal: null,
      targetTotal: 0,
      targetList: [],
      defaultOpenId: '',
      defaultPlatform: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.m-wrap-target {
  overflow-x: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-height: 420px;
  white-space: nowrap;
  padding-bottom: 36px;

  .c-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .ivu-icon {
      display: inline-block;
    }

    span {
      color: #bebebe;
      font-size: 14px;
    }
  }

  .target-wrap {
    width: 280px;
    display: inline-block;
    border: solid 1px #dedede;
    border-radius: 4px;
    margin-left: 22px;
    vertical-align: top;

    &:first-child {
      margin-left: 0;
    }

    header {
      padding: 8px;
      border-bottom: solid 1px #dedede;
      display: flex;
      justify-content: space-between;

      dl {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.2;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin: 0;
      }
    }

    .target-content {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      padding: 8px 0 8px 8px;
      width: 100%;
      max-height: 318px;

      ul {
        margin: 0;
      }

      li {
        padding-top: 6px;
        display: flex;

        dd,
        dt {
          line-height: 18px;
          display: inline-block;
          margin: 0;
        }

        dt {
          color: #333;
          font-weight: 600;
        }

        dd {
          max-width: 230px;
          word-break: break-all;
          white-space: normal;
          color: #888;
        }
      }
    }
  }
}
</style>
